import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import logoLight from '../../assets/peace-logo.png';
import logoDark from '../../assets/peacemobiles-logo-dark.png';

const Header = () => {
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const isAdminLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';

  // Monitor scroll offset to adjust navbar glassmorphism intensity
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-close mobile menu on route change
  useEffect(() => {
    setIsExpanded(false);
  }, [location.pathname]);

  const isSupportActive = location.pathname === '/support' || location.pathname === '/service-centre';
  const currentLogo = theme === 'dark' ? logoDark : logoLight;

  return (
    <header className={`apple-navbar-wrapper ${isScrolled ? 'nav-scrolled' : ''}`}>
      <Navbar
        expand="lg"
        expanded={isExpanded}
        onToggle={(expanded) => setIsExpanded(expanded)}
        className="apple-nav"
      >
        <Container>
          {/* Brand Logo */}
          <Navbar.Brand as={Link} to="/" className="apple-nav-brand" title="PeaceMobiles Homepage">
            <img
              src={currentLogo}
              height="46"
              className="d-inline-block align-middle brand-logo-img"
              alt="PeaceMobiles logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="apple-navbar-nav" className="apple-nav-toggle">
            <span className="toggle-bar"></span>
            <span className="toggle-bar"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="apple-navbar-nav" className="apple-nav-collapse">
            <Nav className="mx-auto apple-nav-links">
              <Nav.Link
                as={Link}
                to="/"
                className={`apple-nav-link ${location.pathname === '/' ? 'active' : ''}`}
              >
                Overview
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/products"
                className={`apple-nav-link ${location.pathname === '/products' ? 'active' : ''}`}
              >
                Mobile Lineup
              </Nav.Link>
              
              {/* Support & Services Dropdown */}
              <NavDropdown
                title="Support & Services"
                id="support-services-dropdown"
                className={`apple-nav-dropdown ${isSupportActive ? 'active' : ''}`}
              >
                <NavDropdown.Item as={Link} to="/service-centre">
                  Service Centers
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/support">
                  Support
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                as={Link}
                to="/contact"
                className={`apple-nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
              >
                Contact
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about"
                className={`apple-nav-link ${location.pathname === '/about' ? 'active' : ''}`}
              >
                About Us
              </Nav.Link>
            </Nav>

            {/* Actions & Theme Toggle */}
            <div className="apple-nav-actions">
              {/* Dark/Light Theme Toggle Button */}
              <button
                type="button"
                onClick={toggleTheme}
                className="theme-toggle-btn"
                aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
                title={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
              >
                {theme === 'dark' ? (
                  <FaSun className="theme-toggle-icon sun-icon" />
                ) : (
                  <FaMoon className="theme-toggle-icon moon-icon" />
                )}
              </button>

              {isAdminLoggedIn && (
                <Link to="/admin/dashboard" className="nav-admin-link">
                  Dashboard
                </Link>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
